import React from "react";
import { ClockIcon } from "lucide-react";
import { useCountdown } from "../hooks/useCountdown";
type CountdownProps = {
  tone?: "light" | "dark";
};
export function Countdown({
  tone = "light"
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Minutes"
  }, {
    value: seconds,
    label: "Seconds"
  }];
  const labelColor = tone === "dark" ? "text-white" : "text-navy";
  return <div className="mt-6 flex flex-col items-center" role="timer" aria-live="off" data-id="element-20" data-mp="3h1idttmfb524">
      <p className={`flex items-center gap-2 text-sm font-bold uppercase tracking-wide ${labelColor}`} data-id="element-21" data-mp="323yccwoqjs0p">
        <ClockIcon className="h-4 w-4" aria-hidden="true" data-id="element-22" data-mp="372jbess945nk" />
        The special offer ends in:
      </p>
      <div className="mt-3 flex items-start gap-2" data-id="element-23" data-mp="10btp3yi6liwb">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-24" data-mp="15bg52fpe9d8t" data-mpi={i}>
            <div className="flex flex-col items-center" data-id="element-25" data-mp="15a4yy98h7tej">
              <span className="flex h-[4.25rem] w-[4.25rem] items-center justify-center rounded-xl bg-navy font-serif text-4xl font-extrabold tabular-nums text-white shadow-lg sm:h-20 sm:w-20 sm:text-5xl" data-id="element-26" data-mp="y0wu5k979ujy">
                {u.value}
              </span>
              <span className={`mt-1.5 text-[11px] font-semibold uppercase tracking-wider ${tone === "dark" ? "text-white/80" : "text-muted"}`} data-id="element-27" data-mp="17qgfcwkdy0hz">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-4 font-serif text-3xl font-bold ${labelColor}`} data-id="element-28" data-mp="a3hee9mnu6ea">:</span>}
          </React.Fragment>)}
      </div>
    </div>;
}